import React, { Component } from 'react'
import { withRouter } from 'react-router-dom'
import { Button } from 'components/elements'
import SearchFilterPopUp from '../searchTippyPopup/searchTippyPopUp'
import { addToUrlPush, removeFromUrlPush } from '../filterUtil.js'
import { STYLE_FILTER_SHORT_NAME, styleDefault } from './styleFilterConfig'
import { PAGE_FILTER_SHORT_NAME } from '../pagination/paginationFilterConfig'
import './../../../theme/assets/styles/updated.sass'

import { bikeCategories } from '../../../../constants'

import ChipGroup from '../../filters/filterInputs/chipGroup.js'

let classNames = require('classnames')

class StyleFilter extends Component {
  constructor(props) {
    super(props)
    this.state = {
      open: false,
      currentStyles: this.props.currentStyles,
      buttonLabel: this.buildButtonLabel(this.props?.currentStyles?.length),
      active: this.isValueDefault(this.props?.currentStyles?.length)
        ? false
        : true,
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.currentStyles !== this.props.currentStyles) {
      this.setState({
        currentStyles: this.props.currentStyles,
        buttonLabel: this.buildButtonLabel(this.props?.currentStyles?.length),
        active: this.isValueDefault(this.props?.currentStyles?.length )
          ? false
          : true,
      })
    }
  }

  handleApply = () => {
    this.closeFilter()
    let tempLocationSearch = this.props.location.search
    if (this.props.location.search?.includes('&page=')) {
      const { string } = removeFromUrlPush(
        [PAGE_FILTER_SHORT_NAME],
        tempLocationSearch
      )
      tempLocationSearch = string
    }

    if (this.isValueDefault(this.state?.currentStyles?.length)) {
      this.setState({ active: false })
      let newQueryString = removeFromUrlPush(
        [STYLE_FILTER_SHORT_NAME],
        tempLocationSearch
      )
      this.props.history.push('?' + newQueryString.string)
    }
    if (!this.isValueDefault(this.state?.currentStyles?.length)) {
      this.setState({ active: true })
      let valuesToAdd = [
        { key: STYLE_FILTER_SHORT_NAME, value: this.state.currentStyles },
      ]
      let newQueryString = addToUrlPush(valuesToAdd, tempLocationSearch)
      this.props.history.push('?' + newQueryString.string)
    }

    this.setState({
      buttonLabel: this.buildButtonLabel(this.state?.currentStyles?.length),
    })
    this.props.onApply(this.state.currentStyles)
  }

  handleOpen = () => {
    this.setState({ open: true })
    this.props.onOpen()
  }

  closeFilter = () => {
    this.setState({ open: false })
    this.props.onClose()
  }

  buildButtonLabel = (count, long) => {
    let newButtonLabel = this.props.defaultLabel

    if (this.isValueDefault(count)) {
      newButtonLabel = 'Style'
    } else {
      newButtonLabel = 'Style · ' + count
    }

    return newButtonLabel
  }

  isValueDefault = (count) => {
    if (!count) {
      return true
    }
    if (count === 0) {
      return true
    } else {
      return false
    }
  }

  render() {
    const { open, buttonLabel, active, currentStyles } = this.state

    let filterBtnClass = classNames(
      'filterBtnClass filters-bar-buttons',
      this.props.className,
      {
        'is-primary': active || open,
      }
    )

    return (
      <SearchFilterPopUp
        triggerClassName={filterBtnClass}
        triggerText={
          <>
            <span>
              {buttonLabel}
            </span>
            <span className="icon mt-1">
              &nbsp;<i className="fa fa-angle-down"></i>
            </span>
          </>
        }
        on="click"
        open={open}
        onClose={() => this.closeFilter()}
        onOpen={() => this.handleOpen()}
      >
        <div className="search-filter-inner-wrapper">
          <ChipGroup
            chipType='bikeCategories'
            chipData={bikeCategories}
            labelKey={'catLabel'}
            valueKey={'catName'}
            iconKey={'catIconUrl'}
            onChange={(values) => this.setState({ currentStyles: values })}
            selectedChips={currentStyles}
          />
          <div className="has-text-right search-filter-apply-btn">
            <Button onClick={this.handleApply}>Apply</Button>
          </div>
        </div>
      </SearchFilterPopUp>
    )
  }
}

export default withRouter(StyleFilter)

StyleFilter.defaultProps = {
  initialStyles: styleDefault,
  defaultLabel: 'Style',
  currentStyles: [],
  onApply: function () { },
  onOpen: function () { },
  onClose: function () { },
  onClear: function () { },
  pushToUrl: true,
}
